import { render, staticRenderFns } from "./UsersRepartitionTable.vue?vue&type=template&id=7bc93ac4&"
import script from "./UsersRepartitionTable.vue?vue&type=script&lang=ts&"
export * from "./UsersRepartitionTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
